// ===== Functionality for announcement-bar section start =====
(function () {
  // Function to fetch the current cart state
  async function fetchCart() {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`);
    return response.json();
  }

  // Function to calculate total value (convert cents to major currency unit)
  function calculateTotalValue(cart) {
    let total = cart.total_price / 100;

    const excludedVendors = ["FragranceBuy", "Fragrancebuy"];
    cart.items.forEach((item) => {
      if (excludedVendors.includes(item.vendor)) {
        total -= item.final_line_price / 100;
      }
    });

    return total;
  }

  // Get currency symbol from Shopify global object
  function getCurrencySymbol() {
    // Shopify Markets exposes the symbol via Shopify.currency (if available)
    if (Shopify?.currency?.active && Shopify?.currency?.symbol) {
      return Shopify.currency.symbol;
    }

    // Fallback if unavailable
    const currencySymbols = {
      USD: "$",
      CAD: "$",
      EUR: "€",
      GBP: "£",
      AUD: "$",
      JPY: "¥",
      CHF: "CHF",
      SEK: "kr",
      NOK: "kr",
      DKK: "kr",
      PLN: "zł",
    };
    const active = Shopify?.currency?.active || "CAD";
    return currencySymbols[active] || active + " ";
  }

  // Function to update progress bar based on qualifyingValue
  function updateProgressBar(qualifyingValue, thresholdType) {
    const totalValueThreshold = parseInt(
      document.querySelector(".announcement-bar")?.dataset.totalDollarValue ||
        "100",
      10,
    );
    const itemCountThreshold = parseInt(
      document.querySelector(".announcement-bar")?.dataset.threshold || "5",
      10,
    );

    // console.log("thresholdType: " + thresholdType);
    // console.log("qualifyingValue: " + qualifyingValue);
    const progressLines = [
      ".progress-bar__line_1",
      ".progress-bar__line_2",
      ".progress-bar__line_3",
      ".progress-bar__line_4",
      ".progress-bar__line_5",
    ];
    const finalResult = ".progress-bar__final-result";

    function toggleClass(selector, shouldBeActive) {
      const elements = document.querySelectorAll(selector);
      if (elements.length === 0) return;
      elements.forEach((el) => el.classList.toggle("active", shouldBeActive));
    }

    // Clear all active classes before setting them
    [...progressLines, finalResult].forEach((sel) => toggleClass(sel, false));

    // Define threshold levels based on thresholdType
    const thresholds =
      thresholdType === "item_count"
        ? Array.from({ length: 5 }, (_, i) =>
            Math.ceil(((i + 1) * itemCountThreshold) / 5),
          )
        : Array.from({ length: 5 }, (_, i) =>
            Math.ceil(((i + 1) * totalValueThreshold) / 5),
          );

    // Set active classes based on qualifyingValue
    progressLines.forEach((selector, i) => {
      if (qualifyingValue >= thresholds[i]) toggleClass(selector, true);
    });

    // Activate finalResult only if conditions are met
    const isFinalActive =
      (thresholdType === "item_count" &&
        qualifyingValue >= itemCountThreshold) ||
      (thresholdType !== "item_count" &&
        qualifyingValue >= totalValueThreshold);
    toggleClass(finalResult, isFinalActive);
  }

  // Function to update each announcement bar dynamically
  async function updateAnnouncementBars() {
    const cart = await fetchCart();
    const announcementBars = document.querySelectorAll(".announcement-bar");
    const currencySymbol = getCurrencySymbol();

    // Loop through all announcement bars on the page
    announcementBars.forEach((announcementBar) => {
      let previousValue = announcementBar.dataset.previousValue || null;
      const messageElement = announcementBar.querySelector(
        ".announcement-bar__text",
      );
      if (!messageElement) return;

      // Data attributes with text from settings
      const qualifiedText = announcementBar.dataset.qualifiedText;
      const itemCountTextOne = announcementBar.dataset.itemCountTextOne;
      const itemCountTextTwo = announcementBar.dataset.itemCountTextTwo;
      const dollarTextOne = announcementBar.dataset.dollarTextOne;
      const itemsNeededMessage = announcementBar.dataset.itemsNeeded;
      const dollarTextTwo = announcementBar.dataset.dollarTextTwo;
      const dollarTextSuffix = announcementBar.dataset.dollarTextSuffix || "!";
      const messageStart = announcementBar.dataset.messageStart || "Add";
      const messageEnd = announcementBar.dataset.messageEnd || " items";

      const thresholdType =
        announcementBar.dataset.thresholdType || "item_count";

      let qualifyingValue, valueNeeded, threshold;

      if (thresholdType === "item_count") {
        // Calculate qualifying item count
        threshold = parseInt(announcementBar.dataset.threshold, 10);
        qualifyingValue = cart.items.reduce((count, item) => {
          return !["FragranceBuy", "Fragrancebuy"].includes(item.vendor)
            ? count + item.quantity
            : count;
        }, 0);
        valueNeeded = Math.max(threshold - qualifyingValue, 0);
      } else if (thresholdType === "dollar_value") {
        // Fetch the threshold dynamically
        threshold =
          parseInt(announcementBar.dataset.totalDollarValue, 10) || 50;

        // Calculate qualifying cart value, adjusted for currency
        const cartValue = calculateTotalValue(cart);
        qualifyingValue = Math.floor(cartValue);
        valueNeeded = Math.max(threshold - qualifyingValue, 0);
      }

      // Update progress bar based on qualifyingValue
      if (qualifyingValue == previousValue) return;
      announcementBar.dataset.previousValue = qualifyingValue;
      updateProgressBar(qualifyingValue, thresholdType);

      // Display appropriate messages based on the qualifying value
      if (valueNeeded <= 0) {
        messageElement.innerHTML = qualifiedText;
      } else if (qualifyingValue === 0) {
        messageElement.innerHTML =
          thresholdType === "item_count"
            ? `${itemCountTextOne} <span class="accent-text-color">${threshold}+</span> ${itemCountTextTwo}`
            : `${dollarTextOne} <span class="accent-text-color">${currencySymbol}${threshold}</span>${dollarTextSuffix}`;
      } else {
        messageElement.innerHTML =
          thresholdType === "item_count"
            ? `${messageStart} <span class="announcement-bar__items-needed">${valueNeeded}</span> ${messageEnd} ${itemsNeededMessage}`
            : `${messageStart} <span class="announcement-bar__amount-needed">${currencySymbol}${Math.floor(valueNeeded)}</span> ${dollarTextTwo}`;
      }
    });
  }

  // Event listener for currency changes
  document.querySelector(".currency-picker")?.addEventListener("change", () => {
    document.querySelectorAll(".announcement-bar").forEach((bar) => {
      bar.dataset.previousValue = null; // Reset per announcement bar
    });
    updateAnnouncementBars();
  });

  // Event listener to trigger updates after cart changes
  document.addEventListener("DOMContentLoaded", () => {
    updateAnnouncementBars();

    // Listen for custom cart update events
    document.body.addEventListener("cart:updated", updateAnnouncementBars);

    let debounceTimer;
    let animationFrameId;
    const cartCountElement = document.querySelector(".cart-drawer");

    if (cartCountElement) {
      const observer = new MutationObserver((mutationsList) => {
        let hasChanges = mutationsList.some((mutation) => {
          return (
            mutation.type === "childList" || mutation.type === "characterData"
          );
        });

        if (hasChanges) {
          if (debounceTimer) {
            clearTimeout(debounceTimer);
          }
          if (animationFrameId) {
            cancelAnimationFrame(animationFrameId);
          }

          // Debounce using requestAnimationFrame
          animationFrameId = requestAnimationFrame(() => {
            // console.log(
            //   "Cart count changed:",
            //   cartCountElement.textContent.trim(),
            // );
            updateAnnouncementBars();
          });
        }
      });

      observer.observe(cartCountElement, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  });
})();
// ===== Functionality for announcement-bar section end =====

// ===== Functionality for mobile menu start =====
(function () {
  document.querySelectorAll(".header__icon--summary").forEach((button) => {
    button.addEventListener("click", () => {
      document.documentElement.classList.toggle("menu-open");
    });
  });
})();
// ===== Functionality for mobile menu end =====

// ===== Geolocation geoip for automatic currency change start =====
(function () {
  // Run once per session
  if (typeof Storage === "undefined") return;
  if (sessionStorage.getItem("currencySet")) return;

  const targetCountry = "CA";
  const userCurrency = "CAD";

  const init = () => {
    const countryCodeInput = document.querySelector(
      "localization-form input[name='country_code']",
    );
    if (!countryCodeInput) return;

    if (countryCodeInput.value === targetCountry) {
      sessionStorage.setItem("currencySet", "isSet");
      sessionStorage.setItem("userCurrency", userCurrency);
      return;
    }

    countryCodeInput.click();

    setTimeout(() => {
      const countryLink = document.querySelector(
        `ul.countries a[data-value="${targetCountry}"]`,
      );
      if (!countryLink) return;

      countryLink.click();
      sessionStorage.setItem("currencySet", "isSet");
      sessionStorage.setItem("userCurrency", userCurrency);
    }, 300);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
// ===== Geolocation geoip for automatic currency change end =====

// ===== Header sticky behavior on desktop and mobile start =====
(function () {
  let currentStickyType = null;

  function updateStickyType() {
    const stickyHeader = document.querySelector("sticky-header");

    if (!stickyHeader) return;

    const newStickyType = window.innerWidth < 992 ? "on-scroll-up" : "always";

    // #1 Update only if the sticky type has changed
    if (currentStickyType !== newStickyType) {
      stickyHeader.setAttribute("data-sticky-type", newStickyType);
      currentStickyType = newStickyType;

      // #2 Force reapply the sticky behavior
      reinitializeStickyBehavior(stickyHeader);
    }
  }

  function reinitializeStickyBehavior(stickyHeader) {
    if (typeof stickyHeader.reinitializeSticky === "function") {
      stickyHeader.reinitializeSticky();
    } else {
      // #3 Force a manual reinitialization by removing and re-adding the element
      const parent = stickyHeader.parentNode;
      const sibling = stickyHeader.nextSibling;

      // #4 Remove the sticky header temporarily
      parent.removeChild(stickyHeader);

      // #5 Re-add the sticky header
      if (sibling) {
        parent.insertBefore(stickyHeader, sibling);
      } else {
        parent.appendChild(stickyHeader);
      }
    }
  }

  updateStickyType();
  window.addEventListener("resize", updateStickyType);
  window.addEventListener("load", updateStickyType);
  window.addEventListener("orientationchange", updateStickyType);
})();
// ===== Header sticky behavior on desktop and mobile end =====

// ===== Functionality for newsletter section info popup start =====
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const resultWrapper = document.querySelector(
      ".newsletter-custom-form__wrapper",
    );
    const closeButton = resultWrapper?.querySelector(".field__button");

    if (closeButton && resultWrapper) {
      closeButton.addEventListener("click", () => {
        resultWrapper.style.display = "none";
      });
    }
  });
})();
// ===== Functionality for newsletter section info popup end =====

// ===== Functionality for image banner slider init start=====
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    document
      .querySelectorAll(".swiper#image_banner")
      .forEach((swiperContainer) => {
        let autoSlideTimeout = null;
        let lastHandledRealIndex = null;

        const shouldAutoplay = swiperContainer.dataset.autoplay === "true";

        const swiper = new Swiper(swiperContainer, {
          slidesPerView: 1,
          grabCursor: true,
          loop: true,
          pagination: {
            el: swiperContainer.querySelector(".swiper-pagination"),
            clickable: true,
          },
          on: {
            init() {
              if (shouldAutoplay) {
                requestAnimationFrame(() =>
                  handleAutoplayForSlide(this, "init"),
                );
              }
            },
            slideChange() {
              this.pagination.render();
              this.pagination.update();
              if (shouldAutoplay) {
                handleAutoplayForSlide(this, "slideChange");
              }
            },
          },
        });

        function getVisibleVideo(slide) {
          const isMobile = window.matchMedia("(max-width: 768px)").matches;
          return isMobile
            ? slide.querySelector(".banner__video_mobile")
            : slide.querySelector(".banner__video_desktop");
        }

        function cleanupVideoListeners(swiperInstance) {
          swiperInstance.slides.forEach((slide) => {
            slide.querySelectorAll("video").forEach((video) => {
              if (video._autoplayHandler) {
                video.removeEventListener("ended", video._autoplayHandler);
                video._autoplayHandler = null;
              }
            });
          });
        }

        function handleAutoplayForSlide(swiperInstance, source) {
          const realIndex = swiperInstance.realIndex;

          if (realIndex === lastHandledRealIndex) {
            return;
          }
          lastHandledRealIndex = realIndex;

          clearTimeout(autoSlideTimeout);

          const currentSlide =
            swiperInstance.slides[swiperInstance.activeIndex];
          if (!currentSlide) return;

          cleanupVideoListeners(swiperInstance);

          const visibleVideo = getVisibleVideo(currentSlide);

          if (visibleVideo) {
            visibleVideo.loop = false;
            visibleVideo.currentTime = 0;
            visibleVideo
              .play()
              .catch((err) => console.warn("Video play error:", err));

            const handler = () => {
              swiperInstance.slideNext();
            };

            visibleVideo._autoplayHandler = handler;
            visibleVideo.addEventListener("ended", handler);
          } else {
            autoSlideTimeout = setTimeout(() => {
              swiperInstance.slideNext();
            }, 5000);
          }
        }
      });
  });
})();

// ===== Functionality for image banner slider init end =====

// ===== Functionality for collections slider init start=====
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const swiper = new Swiper("#swiper-collection", {
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      loop: true,
      speed: 800,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: "#swiper-collection .swiper-button-next",
        prevEl: "#swiper-collection .swiper-button-prev",
      },
      grabCursor: true,
      watchSlidesProgress: true,
      updateOnWindowResize: true,
      on: {
        slideChange: function () {
          this.pagination.render();
          this.pagination.update();
        },
      },
    });
  });
})();
// ===== Functionality for collections slider init end =====

// <!-- Share btn Start -->
// Get Anchors Start
function initializeSocialShareLinks() {
  var WhatsAppLink = shadowRoot.querySelector("#whatsappShareBtn");
  var FaceBookLink = shadowRoot.querySelector("#facebookShareBtn");
  var InstagramLink = shadowRoot.querySelector("#instagramShareBtn");
  var TwitterLink = shadowRoot.querySelector("#twitterShareButton");
  var EmailLink = shadowRoot.querySelector("#emailShareButton");

  // Get Anchors End
  var btn_share_open = document.querySelectorAll(".ctm-cus-button");
  var btn_share_close = shadowRoot.querySelector(".close");
  btn_share_open.forEach(function (element) {
    element.addEventListener("click", function () {
      if (screen.width < 750) {
        shadowRoot.querySelector(".ctm-cus-overlay").style.display = "none";
      } else if (screen.width > 750) {
        shadowRoot.querySelector(".ctm-cus-overlay").style.display = "block";
      }
      let dataShareLink =
        this.getAttribute("data-share-link").split("?variant=")[0];
      if (screen.width > 750) {
        shadowRoot.querySelector("#ctmShareLink").value = dataShareLink;
        // WhatsApp LINK start
        WhatsAppLink.removeAttribute("href");
        WhatsAppLink.setAttribute(
          "href",
          `https://web.whatsapp.com/send?text=${dataShareLink}`,
        );
        // WhatsApp LINK End
        // FaceBook LINK start
        FaceBookLink.removeAttribute("href");
        FaceBookLink.setAttribute(
          "href",
          `https://www.facebook.com/sharer/sharer.php?u=${dataShareLink}`,
        );
        // FaceBook LINK End
        // Instagram LINK start
        InstagramLink.removeAttribute("href");
        InstagramLink.setAttribute(
          "href",
          `https://www.instagram.com/share?url=${dataShareLink}`,
        );
        // Twitter LINK start
        TwitterLink.removeAttribute("href");
        TwitterLink.setAttribute(
          "href",
          `https://twitter.com/intent/tweet?url=${dataShareLink}`,
        );
        // Twitter LINK End
        // Email LINK start
        EmailLink.removeAttribute("href");
        EmailLink.setAttribute(
          "href",
          ` mailto:?subject=I wanted you to see this site&amp;body=${dataShareLink}`,
        );
        // Email LINK End
      }
    });
  });

  btn_share_close.addEventListener("click", function () {
    shadowRoot.querySelector(".ctm-cus-overlay").style.display = "none";
  });
  shadowRoot
    .querySelector(".ctm-cus-overlay")
    .addEventListener("click", function (e) {
      if (e.target.classList.contains("ctm-cus-overlay")) {
        shadowRoot.querySelector(".ctm-cus-overlay").style.display = "none";
      }
    });

  if (screen.width < 750) {
    btn_share_open.forEach(function (element) {
      element.addEventListener("click", function () {
        let dataShareLink = this.getAttribute("data-share-link");

        var shareUrl = this.getAttribute("data-share-link");

        if (navigator.share) {
          // Check if the Web Share API is supported
          navigator
            .share({
              title: "Check out this website!",
              text: "Product",
              url: shareUrl,
            })
            .then(function () {
              console.log("Successfully shared");
            })
            .catch(function (error) {
              console.error("Error sharing:", error);
            });
        } else {
          // Fallback for browsers that don't support Web Share API
          var encodedUrl = encodeURIComponent(shareUrl);
          var shareLink =
            "mailto:?subject=Check%20out%20this%20website&body=I%20found%20this%20interesting%20website:%20" +
            encodedUrl;
          window.location.href = shareLink;
        }
      });
    });
  }
}

// Initialize on page load and page show events
window.addEventListener("load", initializeSocialShareLinks);
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    initializeSocialShareLinks();
  }
});

// Use MutationObserver to reapply event handlers on async updates
document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    initializeSocialShareLinks();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

// <!-- Share btn End -->

// ===== Testimonials section scripts start =====
(function () {
  // #1 Junip API script
  fetch("https://api.juniphq.com/v1/product_reviews?include=customer", {
    method: "GET",
    headers: {
      "Junip-Store-Key": "f7RjbLs8Ayep3CAm5prpzTLE",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      const reviews = data.product_reviews;
      const testimonialsWrapper = document.querySelector(
        ".testimonials__items-wrapper",
      );

      // Ensure testimonialsWrapper exists
      if (!testimonialsWrapper) return;

      const existingElements = Array.from(testimonialsWrapper.children);

      // Ensure there are enough reusable elements and create more if needed
      while (existingElements.length < reviews.length) {
        const clone = existingElements[0].cloneNode(true);
        testimonialsWrapper.appendChild(clone);
        existingElements.push(clone);
      }

      // Character limit based on screen width
      const updateReviewContent = () => {
        const charLimit = window.innerWidth >= 992 ? 160 : 105;

        reviews.forEach((review, index) => {
          const userName = review.customer?.first_name || "Anonymous";
          const rating = review.rating;
          const reviewText = review.body;
          const reviewElement = existingElements[index];

          reviewElement.classList.add("scroll-trigger", "animate--slide-in");
          reviewElement.querySelector(".item-testimonials__name").textContent =
            userName;
          reviewElement.querySelector(".item-testimonials__rating").innerHTML =
            generateStars(rating);

          // "Read More" functionality
          const contentElement = reviewElement.querySelector(
            ".item-testimonials__content",
          );
          if (reviewText.length > charLimit) {
            contentElement.innerHTML = `
              <span class="truncated-text">${reviewText.substring(0, charLimit)}...</span>
              <span class="full-text hidden">${reviewText}</span>
              <a href="#" class="read-more">Read more</a>
            `;

            // Add click event listener for "Read more"
            contentElement
              .querySelector(".read-more")
              .addEventListener("click", (event) => {
                event.preventDefault();
                contentElement
                  .querySelector(".truncated-text")
                  .classList.add("hidden");
                contentElement
                  .querySelector(".full-text")
                  .classList.remove("hidden");
                event.target.remove();
              });
          } else {
            contentElement.textContent = reviewText;
          }
        });
      };

      updateReviewContent();

      // #2 Slider swiper functionality (Initialize Swiper only after content is loaded)
      const swiper = new Swiper(".testimonials__items", {
        slidesPerView: "auto",
        spaceBetween: 10,
        grabCursor: true,
        navigation: {
          nextEl: ".swiper-button-next.testimonials",
          prevEl: ".swiper-button-prev.testimonials",
        },
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
          clickable: true,
        },
      });

      swiper.update();

      window.addEventListener("load", updateReviewContent);
      window.addEventListener("resize", updateReviewContent);
      window.addEventListener("orientationchange", updateReviewContent);
    })
    .catch((error) => console.error("Error fetching reviews:", error));

  function generateStars(rating) {
    const starIconSVG = `
      <svg class="icon icon-star" width="12" height="12" viewBox="0 0 12 12" fill="none" fill-rule="evenodd" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.36956 0.673072C5.43376 0.562915 5.52571 0.471516 5.63626 0.40799C5.7468 0.344465 5.87207 0.311035 5.99956 0.311035C6.12706 0.311035 6.25233 0.344465 6.36287 0.40799C6.47342 0.471516 6.56537 0.562915 6.62956 0.673072L8.25998 3.47191L11.4263 4.15791C11.5509 4.18497 11.6661 4.24421 11.7607 4.32972C11.8552 4.41522 11.9256 4.52401 11.965 4.64524C12.0044 4.76646 12.0113 4.89588 11.985 5.02061C11.9588 5.14533 11.9003 5.261 11.8154 5.35607L9.65706 7.77166L9.98373 10.9946C9.99662 11.1215 9.97599 11.2495 9.9239 11.366C9.87181 11.4824 9.79009 11.5832 9.68689 11.6581C9.58369 11.7331 9.46263 11.7797 9.33579 11.7933C9.20895 11.8068 9.08078 11.7869 8.96406 11.7354L5.99956 10.4287L3.03506 11.7354C2.91835 11.7869 2.79017 11.8068 2.66334 11.7933C2.5365 11.7797 2.41544 11.7331 2.31224 11.6581C2.20904 11.5832 2.12732 11.4824 2.07523 11.366C2.02314 11.2495 2.00251 11.1215 2.0154 10.9946L2.34206 7.77166L0.183731 5.35666C0.0986969 5.26159 0.0400881 5.14588 0.0137554 5.02107C-0.0125772 4.89627 -0.0057124 4.76675 0.0336645 4.64543C0.0730414 4.52411 0.143553 4.41524 0.238159 4.3297C0.332766 4.24415 0.448157 4.18491 0.572814 4.15791L3.73915 3.47191L5.36956 0.673072Z" fill="currentColor"/>
      </svg>`;
    return Array(rating).fill(starIconSVG).join("");
  }
})();
// ===== Testimonials section scripts end =====

// <!-- Featured collection swiper start-->
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    function initializeSwiper() {
      const swiperContainer = document.querySelector(
        "#swiper-featured-collection",
      );
      if (!swiperContainer) return;

      const viewportWidth = window.innerWidth;

      if (viewportWidth <= 992) {
        if (!swiperContainer.swiper) {
          new Swiper("#swiper-featured-collection", {
            slidesPerView: "auto",
            grabCursor: true,
            loop: true,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            on: {
              slideChange: function () {
                this.pagination.render();
                this.pagination.update();
              },
            },
          });
        }
      } else {
        if (swiperContainer.swiper) {
          swiperContainer.swiper.destroy(true, true);
        }
      }
    }

    initializeSwiper();

    window.addEventListener("resize", initializeSwiper);
  });
})();
// <!-- Featured collection swiper end-->

// <!-- Tester tooltip start-->
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    document.body.addEventListener("click", function (e) {
      const target = e.target;

      if (!(target instanceof Element)) {
        return;
      }

      const trigger = target.closest(".option__tooltip_text");
      const tooltip = target.closest(".option__tooltip_hover");

      const closeAll = () => {
        document
          .querySelectorAll(".option__tooltip_hover.visible")
          .forEach((el) =>
            el.classList.remove("visible", "is-right", "is-left"),
          );
      };

      if (trigger) {
        const relatedTooltip = trigger
          .closest(".option__tooltip")
          ?.querySelector(".option__tooltip_hover");

        if (!relatedTooltip) return;

        const isOpen = relatedTooltip.classList.contains("visible");

        closeAll();

        if (!isOpen) {
          relatedTooltip.classList.add("visible");

          const rect = relatedTooltip.getBoundingClientRect();
          const viewportWidth = window.innerWidth;

          if (rect.right > viewportWidth) {
            relatedTooltip.classList.add("is-right");
          }
          if (rect.left < 0) {
            relatedTooltip.classList.add("is-left");
          }
        }

        return;
      }

      if (tooltip) {
        return;
      }

      closeAll();
    });
  });
})();
// <!-- Tester tooltip end-->

// ===== Functionality for related slider init start=====
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          const targetElement = document.querySelector(".swiper-related");
          if (targetElement) {
            const swiper = new Swiper("#swiper-related", {
              slidesPerView: "auto",
              speed: 1000,
              spaceBetween: 40,
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
              navigation: {
                nextEl: ".swiper-button-next.related",
                prevEl: ".swiper-button-prev.related",
              },
              grabCursor: true,
              watchSlidesProgress: true,
              updateOnWindowResize: true,
              autoplay: window.matchMedia("(max-width: 992px)").matches
                ? {
                    delay: 3000,
                    disableOnInteraction: false,
                  }
                : false,
              on: {
                slideChange: function () {
                  this.pagination.render();
                  this.pagination.update();
                },
              },
            });
            observer.disconnect();
            break;
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
})();
// ===== Functionality for related slider init end =====

// ===== Accordion functionality in header-drawer (Mega menu mobile) start =====
(function () {
  const accordionDetails = document.querySelectorAll(
    ".menu-drawer-custom .accordion details",
  );

  if (accordionDetails.length > 0) {
    accordionDetails.forEach((detail) => {
      detail.addEventListener("click", function () {
        accordionDetails.forEach((otherDetail) => {
          if (otherDetail !== detail) {
            otherDetail.removeAttribute("open");
          }
        });
      });
    });
  }
})();
// ===== Accordion functionality in header-drawer (Mega menu mobile) end =====

// ===== Update state of checked product on the new page for sync with dropdown start =====
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    if (window.location.pathname.startsWith("/products/")) {
      const optionsWrapper = document.querySelector(".options__wrapper");
      let selectedOption;
      if (!optionsWrapper) {
        return;
      } else {
        selectedOption = optionsWrapper.querySelector(
          'input[type="radio"]:checked',
        );
      }

      if (selectedOption) {
        const label = document.querySelector(
          `label[for="${selectedOption.id}"]`,
        );
        if (label) {
          sessionStorage.setItem(
            "selectedDropdownText",
            label.textContent.trim(),
          );
        }
      }
    }
  });
})();
// ===== Update state of checked product on the new page for sync with dropdown  end =====

// ===== Dynamically set min height for container which held info to be transferred to sticky menu start =====
(function () {
  function updateMinHeight() {
    const sourceDiv = document.getElementById("sticky_menu_wrapper");
    const targetDiv = document.getElementById("main_info_container");

    if (sourceDiv && targetDiv && window.innerWidth <= 993) {
      targetDiv.style.minHeight = `${sourceDiv.offsetHeight}px`;
    } else if (targetDiv) {
      targetDiv.style.minHeight = "";
    }
  }

  window.addEventListener("load", updateMinHeight);
  window.addEventListener("resize", updateMinHeight);
})();
// ===== Dynamically set min height for container which held info to be transferred to sticky menu end =====

// ===== Observe container position to transfer needed info to sticky menu  and transfer it start =====
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    let observer = null;

    function initObserver() {
      if (observer) observer.disconnect();

      const sourceContainerForCopy = document.getElementById(
        "sticky_menu_wrapper",
      );
      const destinationContainerForCopy =
        document.getElementById("sticky_buy_wrapper");
      const containerToObserve = document.getElementById("main_info_container");
      const buyButton = document.getElementById("buy-buttons-wrapper");

      observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          buyButton.classList.remove("is-sticky");
          moveElements(destinationContainerForCopy, sourceContainerForCopy);
        } else {
          if (buyButton) {
            buyButton.classList.add("is-sticky");
          }
          moveElements(sourceContainerForCopy, destinationContainerForCopy);
        }
      });

      observer.observe(containerToObserve);
    }

    function moveElements(fromContainer, toContainer) {
      if (!fromContainer || !toContainer) {
        return;
      }

      const radios = fromContainer.querySelectorAll('input[type="radio"]');
      const checkedValues = {};

      radios.forEach((radio) => {
        if (radio.checked) {
          checkedValues[radio.name] = radio.value;
        }
      });

      while (fromContainer.firstChild) {
        toContainer.appendChild(fromContainer.firstChild);
      }

      const movedRadios = toContainer.querySelectorAll('input[type="radio"]');
      movedRadios.forEach((radio) => {
        if (checkedValues[radio.name] === radio.value) {
          radio.checked = true;
        }
      });
    }

    function handleResize() {
      if (window.innerWidth < 993) {
        if (!observer) {
          initObserver();
        }
      } else {
        if (observer) {
          observer.disconnect();
          observer = null;
        }
      }
    }

    if (window.innerWidth < 993) {
      initObserver();
    }

    window.addEventListener("resize", handleResize);
  });
})();
// ===== Observe container position to transfer needed info to sticky menu  and transfer it end =====

// ===== Disable click on photo on mobile devices start =====
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const disableClicks = () => {
      const components = document.querySelectorAll(".product__modal-opener");

      components.forEach((component) => {
        if (window.innerWidth < 993) {
          component.style.pointerEvents = "none";
        } else {
          component.style.pointerEvents = "auto";
        }
      });
    };

    disableClicks();

    window.addEventListener("resize", disableClicks);
  });
})();
// ===== Dynamically set min height for container which held info to be transferred to sticky menu end =====

// ===== Radio buttons (sticky buy menu) to dropdown functionality start =====
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    let selectedText = sessionStorage.getItem("selectedDropdownText") || "";
    // for debugging
    // console.log("selected text", selectedText);

    function updateDropdownHeader(text) {
      const headers = document.querySelectorAll(".dropdown-header__text");
      headers.forEach((el) => {
        if (!el.dataset.temp) {
          el.textContent = text || "Size";
        }
      });
    }

    updateDropdownHeader(selectedText);

    document.addEventListener("click", (e) => {
      const dropdown = e.target.closest(".dropdown");
      if (!dropdown) return;

      const dropdownHeader = dropdown.querySelector(".dropdown-header");
      const dropdownHeaderText = dropdown.querySelector(
        ".dropdown-header__text",
      );
      const dropdownOptions = dropdown.querySelector(".options__wrapper");

      if (!dropdownHeaderText) return;

      if (e.target.closest(".dropdown-header")) {
        const isOpening = !dropdownOptions.classList.contains("active");

        if (isOpening) {
          dropdownHeaderText.dataset.temp = "true";
          dropdownHeaderText.textContent = "Select a variant";
        } else {
          delete dropdownHeaderText.dataset.temp;
          dropdownHeaderText.textContent = selectedText || "Select a variant";
        }

        dropdownOptions.classList.toggle("active");
        dropdownHeader.classList.toggle("active");
      }

      const selectedInput = e.target.closest('input[type="radio"]');
      if (selectedInput) {
        const label = document.querySelector(
          `label[for="${selectedInput.id}"]`,
        );
        if (label) {
          selectedText = label.textContent.trim();
          sessionStorage.setItem("selectedDropdownText", selectedText);
        }

        dropdownOptions.classList.remove("active");
        dropdownHeader.classList.remove("active");

        setTimeout(() => {
          let tries = 0;
          const maxTries = 20;

          const retry = () => {
            const el = document.querySelector(".dropdown-header__text");
            if (el) {
              el.textContent =
                sessionStorage.getItem("selectedDropdownText") || "Size";
            } else if (++tries < maxTries) {
              setTimeout(retry, 100);
            } else {
              console.warn("Gave up after", maxTries, "tries");
            }
          };

          retry();
        }, 500);
      }
    });

    document.addEventListener(
      "click",
      (e) => {
        if (!e.target.closest(".dropdown")) {
          document
            .querySelectorAll(".options__wrapper")
            .forEach((el) => el.classList.remove("active"));
          document
            .querySelectorAll(".dropdown-header")
            .forEach((el) => el.classList.remove("active"));

          document.querySelectorAll(".dropdown-header__text").forEach((el) => {
            if (el.dataset.temp) {
              el.textContent = selectedText || "Select a variant";
              delete el.dataset.temp;
            }
          });
        }
      },
      true,
    );
  });
})();

// ===== Radio buttons (sticky buy menu) to dropdown functionality end =====

// ===== Price range slider for search result page =====
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    function initializePriceSlider() {
      // Function to initialize a single slider instance
      const initializeSingleSlider = (priceSlider, inputFrom, inputTo) => {
        if (priceSlider) {
          // console.log('Price slider element found:', priceSlider);

          const inputs = [inputFrom, inputTo];

          // Ensure the inputs are present
          if (!inputFrom || !inputTo) {
            // console.error('Input elements not found');
            return;
          }

          // Get initial values from inputs or set defaults
          const startMin = Number(inputFrom.value) || 0;
          const startMax =
            Number(inputTo.value) || Number(inputTo.getAttribute("max")) || 100;
          const rangeMax = Number(inputTo.getAttribute("max")) || 100;

          // Log the initial values for debugging
          // console.log('Initial values for slider:', startMin, startMax, rangeMax);

          // Remove any existing slider instance
          if (priceSlider.noUiSlider) {
            priceSlider.noUiSlider.destroy();
          }

          // Initialize the slider with the start and range values
          noUiSlider.create(priceSlider, {
            start: [startMin, startMax],
            connect: true,
            step: 1,
            range: {
              min: 0,
              max: rangeMax,
            },
          });

          // console.log('Slider initialized');

          // Flag to indicate initial setup
          let initialLoad = true;

          // Update input fields when slider is moved or set
          priceSlider.noUiSlider.on("update", function (values, handle) {
            // console.log('Slider update:', values, handle);
            if (!initialLoad) {
              inputs[handle].value = Math.round(values[handle]);
              inputs[handle].dispatchEvent(
                new Event("input", { bubbles: true }),
              ); // Dispatch input event
            } else {
              inputs[handle].value = Math.round(values[handle]);
            }
          });

          // Set slider when inputs are changed
          inputs.forEach((el, index) => {
            el.addEventListener("change", function () {
              // console.log('Input change:', this.value);
              let value = Number(this.value);
              let values = priceSlider.noUiSlider.get();
              values[index] = value;
              priceSlider.noUiSlider.set(values);
              // Dispatch change event for active-facets update
              if (!initialLoad) {
                el.dispatchEvent(new Event("input", { bubbles: true }));
                el.dispatchEvent(new Event("change", { bubbles: true }));
              }
            });
          });

          // Disable initial load flag after initial setup
          initialLoad = false;
        } else {
          // console.error('Price slider element not found');
        }
      };

      // Initialize all price sliders on the page
      function initializeAllPriceSliders() {
        const priceSliderElements = document.querySelectorAll(
          ".filter-price__slider",
        );
        priceSliderElements.forEach((sliderElement) => {
          const inputFrom = sliderElement
            .closest("details")
            .querySelector(".input-from");
          const inputTo = sliderElement
            .closest("details")
            .querySelector(".input-to");
          initializeSingleSlider(sliderElement, inputFrom, inputTo);
        });
      }

      function observeFilterFormChanges() {
        const filterForm = document.querySelector("facet-filters-form");

        if (filterForm) {
          // console.log('Filter form element found:', filterForm);

          const observer = new MutationObserver(() => {
            // console.log('Filter form mutated');
            initializeAllPriceSliders();
          });

          observer.observe(filterForm, {
            childList: true,
            subtree: true,
          });

          // console.log('Mutation observer set up');
        } else {
          // console.error('Filter form element not found');
        }
      }

      initializeAllPriceSliders();
      observeFilterFormChanges();
    }

    initializePriceSlider();
  });
})();
// ===== Price range slider for search result page =====

// ===== Script for alphabetical list to handle checkbox selection start =====
(function () {
  function toggleFilters(letter) {
    let checkboxes = document.querySelectorAll(
      `.facets-custom input[type="checkbox"][name="filter.p.vendor"], 
       .mobile-facets-custom input[type="checkbox"][name="filter.p.vendor"]`,
    );

    let letterCheckboxes = Array.from(checkboxes).filter((checkbox) =>
      checkbox.value.trim().toUpperCase().startsWith(letter),
    );

    if (letterCheckboxes.length === 0) return;

    // #1 Check if any of the relevant checkboxes are unchecked
    let shouldCheck = letterCheckboxes.some((checkbox) => !checkbox.checked);

    // #2 Set all relevant checkboxes based on shouldCheck
    letterCheckboxes.forEach((checkbox) => {
      if (checkbox.checked !== shouldCheck) {
        checkbox.click();
      }
    });
  }

  document.body.addEventListener("click", function (event) {
    let letterElement = event.target.closest(".grouped-letter");
    if (letterElement) {
      let letter = letterElement.getAttribute("data-letter");
      toggleFilters(letter);
    }
  });

  document.body.addEventListener("keydown", function (event) {
    if (event.key === "Enter" || event.key === " ") {
      let letterElement = document.activeElement.closest(".grouped-letter");
      if (letterElement) {
        event.preventDefault(); // #3 Prevent scrolling on space key
        let letter = letterElement.getAttribute("data-letter");
        toggleFilters(letter);
      }
    }
  });
})();

// ===== Script for alphabetical list to handle checkbox selection end =====

// ===== Helper function for the close filter button start =====
(function () {
  document.body.addEventListener("click", (e) => {
    if (e.target.closest(".mobile-facets__close")) {
      document.body.classList.remove("overflow-hidden-mobile");
    }
  });

  document.body.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === "Escape") {
      document.body.classList.remove("overflow-hidden-mobile");
    }
  });
})();
// ===== Helper function for the close filter button end =====

// ===== Shipping page map pin - info dropdown functionality start =====
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const pinsContainer = document.querySelector(".shipping-image__wrapper");
    const accordions = document.querySelectorAll(".product__accordion details");
    const pins = document.querySelectorAll(".shipping-image-pin__icon");

    function removeOpenedClasses() {
      pins.forEach((pin) => pin.classList.remove("opened"));
    }

    function closeAllAccordions(except = null) {
      accordions.forEach((details) => {
        if (details !== except) {
          details.open = false;
        }
      });
    }

    function updatePinState(accordionId) {
      removeOpenedClasses();

      requestAnimationFrame(() => {
        const correspondingPin = document.querySelector(
          `.shipping-image-pin__icon[data-target="${accordionId}"]`,
        );
        if (correspondingPin) {
          correspondingPin.classList.add("opened");
        }
      });
    }

    function handlePinClick(event) {
      const pin = event.target.closest(".shipping-image-pin__icon");
      if (!pin) return;

      const targetId = pin.getAttribute("data-target");

      const targetAccordion = document.getElementById(targetId);

      if (targetAccordion) {
        closeAllAccordions(targetAccordion);
        targetAccordion.open = true;
        targetAccordion.scrollIntoView({ behavior: "smooth", block: "center" });
        updatePinState(targetId);
      }
    }

    function handleAccordionToggle(event) {
      const details = event.target.closest("details");
      if (!details) return;

      if (details.open) {
        closeAllAccordions(details);
        updatePinState(details.id);
      } else {
        removeOpenedClasses();
      }
    }

    if (pinsContainer) {
      pinsContainer.addEventListener("click", handlePinClick);
    }

    accordions.forEach((accordion) => {
      accordion.addEventListener("toggle", handleAccordionToggle);
    });
  });
})();

// ===== Shipping page map pin - info dropdown functionality end =====

// ===== Counter banner start =====
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const counterBanner = document.getElementById("counter_banner");
    const numbers = document.querySelectorAll(".number");

    if (!counterBanner) return;

    let hasAnimated = false;

    function animateNumbers() {
      const windowWidth = window.innerWidth;

      numbers.forEach((number, index) => {
        number.innerHTML = "";

        const value = parseInt(number.getAttribute("data-value"));
        const span = document.createElement("span");

        span.innerHTML = Array.from(
          { length: 10 },
          (_, i) => `<span>${i}</span>`,
        ).join("");
        number.appendChild(span);

        let translateY;
        if (windowWidth < 993) {
          translateY = 240 - value * 51;
        } else {
          translateY = 235 - value * 51;
        }

        setTimeout(() => {
          span.style.transform = `translateY(${translateY}px)`;
        }, index * 200);
      });
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateNumbers();
            hasAnimated = true;
          }
        });
      },
      { threshold: 0.5 },
    );

    observer.observe(counterBanner);

    window.addEventListener("resize", () => {
      if (hasAnimated) {
        animateNumbers();
      }
    });
  });
})();

// ===== Counter banner end =====

// ===== Helper function for Cart Drawer start =====
(function () {
  const html = document.documentElement;
  const drawer = document.querySelector(".drawer-custom");

  const toggleOverflow = (add) => html.classList.toggle("overflow-hidden", add);

  const isCartPage = window.location.pathname === "/cart";

  // Only proceed with the event listener if not on the /cart page
  if (!isCartPage) {
    const observer = new MutationObserver(() => {
      if (drawer.classList.contains("active")) {
        toggleOverflow(true);
      } else {
        toggleOverflow(false);
      }
    });

    // Observe the 'class' attribute of the drawer element
    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }
})();
// ===== Helper function for Cart Drawer end =====

// ===== Function for dynamically updating the counter in the main cart start =====
(function () {
  function onCartUpdate() {
    fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((data) => {
        // Debugging
        // console.log("Cart updated. Item count:", data.item_count);

        const cartCountElement = document.querySelector(".counter");
        const progressBar = document.querySelector(
          ".cart-custom .header-drawer__progress-bar.progress-bar",
        );
        const cartItems = document.querySelector(".cart-custom cart-items");

        if (cartCountElement) {
          cartCountElement.textContent = `(${data.item_count})`; // #1 Update UI
        }

        // #1.1 Toggle .hidden class for progress bar
        if (progressBar) {
          progressBar.classList.toggle("hidden", data.item_count < 1);
        }

        // #1.2 Toggle .no-top-padding class for cart-items
        if (cartItems) {
          cartItems.classList.toggle("no-top-padding", data.item_count < 1);
        }
      })
      .catch((error) => console.error("Error fetching cart data:", error));
  }

  if (typeof Shopify !== "undefined") {
    Shopify.onCartUpdate = onCartUpdate;
  }

  // #2 Add event listeners to all necessary buttons
  function attachCartListeners() {
    // #3 Listen for quantity change and quick add buttons
    document
      .querySelectorAll(".quantity__button, .quick-add__submit")
      .forEach((button) => {
        button.addEventListener("click", () => {
          setTimeout(onCartUpdate, 500);
        });
      });

    // #4 Listen for cart remove button clicks
    document.querySelectorAll("cart-remove-button").forEach((button) => {
      button.addEventListener("click", () => {
        setTimeout(onCartUpdate, 500);
      });
    });
  }

  attachCartListeners();

  // #5 Use MutationObserver to track dynamically added elements (including remove buttons)
  const observer = new MutationObserver(() => attachCartListeners());
  observer.observe(document.body, { childList: true, subtree: true });
})();
// ===== Function for dynamically updating the counter in the main cart end =====

// ===== Functionality for swiper-related-snippet slider during asynchronous operations start =====
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    let swiper;
    let cartItemCount = 0;
    let swiperUpdateTimeout;

    // Function to initialize Swiper
    function initializeSwiper() {
      const swiperElement = document.querySelector("#swiper-related-snippet");

      if (!swiperElement) return; // Exit if element does not exist

      if (swiper && typeof swiper.destroy === "function") {
        swiper.destroy(true, true); // Destroy existing Swiper instance
      }

      swiper = new Swiper("#swiper-related-snippet", {
        observer: true,
        observeParents: true,
        slidesPerView: "auto",
        speed: 1000,
        spaceBetween: 20,
        grabCursor: true,
        watchSlidesProgress: true,
        updateOnWindowResize: true,
        navigation: {
          nextEl: ".swiper-button-next.related-snippet",
          prevEl: ".swiper-button-prev.related-snippet",
        },
        pagination: {
          el: "#swiper-related-snippet .swiper-pagination",
          clickable: true,
        },
        autoplay: window.matchMedia("(max-width: 992px)").matches
          ? {
              delay: 3000,
              disableOnInteraction: false,
            }
          : false,
        on: {
          observerUpdate: function () {
            clearTimeout(swiperUpdateTimeout);
            swiperUpdateTimeout = setTimeout(() => {
              if (swiper && swiper.update) {
                swiper.update();
              }
            }, 500);
          },
          slideChange: function () {
            this.pagination.render();
            this.pagination.update();
          },
        },
      });
    }

    // Function to handle cart updates (debounced)
    function onCartUpdate() {
      clearTimeout(swiperUpdateTimeout);
      swiperUpdateTimeout = setTimeout(() => {
        fetch(window.Shopify.routes.root + "cart.js")
          .then((response) => response.json())
          .then((data) => {
            if (data.item_count !== cartItemCount) {
              cartItemCount = data.item_count;
              initializeSwiper();
            }
          })
          .catch((error) => console.error("Error fetching cart data:", error));
      }, 500);
    }

    if (typeof Shopify !== "undefined") {
      Shopify.onCartUpdate = onCartUpdate;
    }

    // **Attach event listeners for cart actions using event delegation**
    document.body.addEventListener("click", function (event) {
      if (
        event.target.matches(
          ".quick-add__submit, .product-form__submit, .quantity__button, cart-remove-button, .form__insurance-input",
        )
      ) {
        onCartUpdate();
      }
    });

    // **Monitor if the Swiper container gets re-added (during AJAX updates)**
    const swiperContainerObserver = new MutationObserver(() => {
      const swiperElement = document.querySelector("#swiper-related-snippet");
      if (
        swiperElement &&
        !swiperElement.classList.contains("swiper-initialized")
      ) {
        initializeSwiper();
      }
    });

    swiperContainerObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // **Observe the class changes on Swiper**
    const swiperObserver = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          const swiperElement = mutation.target;
          if (!swiperElement.classList.contains("swiper-initialized")) {
            initializeSwiper();
          }
        }
      });
    });

    const swiperElement = document.querySelector("#swiper-related-snippet");
    if (swiperElement) {
      swiperObserver.observe(swiperElement, { attributes: true });
    }

    // Function to add the 'cart' class to the 'related-products' element if on the cart page
    function updatePageElements() {
      if (
        window.location.pathname.includes("/cart") ||
        window.location.pathname.includes("/search")
      ) {
        const relatedProducts = document.querySelectorAll(".related-products");
        const sliderControls = document.querySelectorAll(
          ".swiper-button-prev.related-snippet, .swiper-button-next.related-snippet, .slider__controls",
        );
        if (relatedProducts.length > 0 && sliderControls.length > 0) {
          relatedProducts.forEach((el) => el.classList.add("cart"));
          sliderControls.forEach((el) => el.classList.remove("hidden"));
        }
      }
    }
    updatePageElements();

    // Fallback for titles while asynchronous actions
    function observeCartTitle() {
      const observer = new MutationObserver(() => {
        const headings = document.querySelectorAll(
          ".related-products__heading",
        );
        const headingCart = document.querySelector(
          ".related-products__heading_cart",
        );

        if (headings && headingCart) {
          // Find the first normal heading after headingCart
          const nextHeading = headingCart.nextElementSibling;

          if (
            nextHeading &&
            nextHeading.classList.contains("related-products__heading")
          ) {
            headingCart.classList.add("hidden");
          } else {
            headingCart.classList.remove("hidden");
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
    observeCartTitle();

    // Function to remove onclick attributes that appear during asynchronous operations
    (function () {
      if (window.location.pathname !== "/") return;

      const observer = new MutationObserver(() => {
        document
          .querySelectorAll(".related-products .quick-add__submit[onclick]")
          .forEach((el) => el.removeAttribute("onclick"));
      });

      observer.observe(document.body, { childList: true, subtree: true });
    })();

    initializeSwiper();
  });
})();
// ===== Functionality for swiper-related-snippet slider during asynchronous operations end =====

// ===== Helper script for tooltip and related features on Collection and Search pages start =====
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    document.addEventListener("click", (event) => {
      const button = event.target.closest(".tooltip__button");
      if (button) {
        const tooltip = button.closest(".field__tooltip");
        if (tooltip) {
          tooltip.classList.add("hidden");
        }

        const facets = document.querySelectorAll(".facets-vertical-sort");
        if (facets.length > 0) {
          facets.forEach((el) => el.classList.remove("more-margin"));
        }

        const heading = document.querySelector(
          ".facets-vertical-form__heading_mobile",
        );
        if (heading) {
          heading.classList.remove("more-margin");
        }
      }
    });
  });
})();
// ===== Helper script for tooltip and related features on Collection and Search pages end =====

// ===== Functionality for Insurance toggle start =====
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    // Market-based disable check
    const autoAddDisabled = window.disableInsuranceAutoAdd === true;

    // Check if the current page is the cart page
    const isCartPage = window.location.pathname.includes("/cart");

    // Remove insurance_removed from sessionStorage when not on cart page
    if (!isCartPage) {
      sessionStorage.removeItem("insurance_removed");
    }

    let lastCartState = { hasProducts: false, onlyInsurance: false };
    let observerInitialized = false;
    let debounceTimeout;

    // Debounce function to limit the frequency of onCartUpdate calls
    function debounceCartUpdate() {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(onCartUpdate, 150);
    }

    function getInsuranceProductId() {
      const insuranceInput = document.querySelector(".form__insurance-input");
      return insuranceInput ? insuranceInput.dataset.pid : null;
    }

    function isInsuranceProductPage() {
      const insuranceId = getInsuranceProductId();
      if (!insuranceId) return false;

      return window.location.pathname.includes("/products/fragbuycare");
    }

    // Function to remove a "phantom" product when adding it asynchronously
    function monitorCartChanges() {
      const cartItemsContainer =
        document.querySelector("#main-cart-items") ||
        document.querySelector(".cart");
      // console.log("Watching cartItemsContainer:", cartItemsContainer);

      if (!cartItemsContainer) return;

      // console.log("Mutation detected in cart.");
      requestAnimationFrame(() => {
        const insuranceProductId = getInsuranceProductId();
        // console.log("Checking for insurance product:", insuranceProductId);

        if (insuranceProductId) {
          const insuranceProductExists = document.querySelector(
            `.cart-item[data-product-id="${insuranceProductId}"], .cart__item[data-product-id="${insuranceProductId}"]`,
          );

          // console.log("Insurance product exists:", !!insuranceProductExists);

          if (
            insuranceProductExists &&
            sessionStorage.getItem("insurance_removed") === "true"
          ) {
            // console.warn("Phantom insurance detected! Reloading...");
            setTimeout(() => window.location.reload(), 500);
          }
        }
      });
    }

    // Fetch settings and apply insurance logic
    function fetchSettingsAndApply() {
      if (!isCartPage) return;
      if (autoAddDisabled) return; // skip auto add

      const insuranceCheckbox = document.querySelector(
        ".form__insurance-input",
      );
      if (!insuranceCheckbox) return;

      const enableInsurance =
        insuranceCheckbox.dataset.insuranceState === "true";
      const userRemovedInsurance =
        sessionStorage.getItem("insurance_removed") === "true";

      if (enableInsurance && !userRemovedInsurance) {
        insuranceCheckbox.checked = true;
        triggerInsuranceAdd();
      }
    }

    // Trigger adding the insurance product
    function triggerInsuranceAdd() {
      document.querySelectorAll(".insurance-product-add").forEach((button) => {
        if (!button.disabled && button.offsetParent !== null) {
          // console.log("Clicking insurance add button:", button);
          button.click();

          // For fix totals cart price updating after asynchronous adding insurance product
          if (window.location.pathname.endsWith("/cart")) {
            setTimeout(() => {
              window.location.reload();
            }, 500);
          }
        }
      });
    }

    // Trigger removing the insurance product
    function triggerInsuranceRemove() {
      document
        .querySelectorAll(".insurance-product-remove")
        .forEach((button) => {
          if (!button.disabled && button.offsetParent !== null) {
            // console.log("Clicking insurance remove button:", button);
            button.click();
          }
        });
    }

    // Handle cart update
    let lastCartFetchTime = 0;
    let isFetchingCart = false;
    const CART_FETCH_COOLDOWN = 300;

    function safeFetchCart() {
      const now = Date.now();
      if (isFetchingCart || now - lastCartFetchTime < CART_FETCH_COOLDOWN) {
        // console.log("Skipping redundant fetch");
        return Promise.resolve(null);
      }

      isFetchingCart = true;
      lastCartFetchTime = now;

      return fetch(`${window.Shopify.routes.root}cart.js?_=${now}`)
        .then((response) => response.json())
        .finally(() => {
          isFetchingCart = false;
        })
        .catch((error) => {
          console.error("Error fetching cart data:", error);
          return null;
        });
    }

    if (isInsuranceProductPage()) {
      // console.log("Insurance product page detected — automation disabled.");

      safeFetchCart().then((data) => {
        if (!data) return;
      });

      return;
    }

    function onCartUpdate() {
      if (autoAddDisabled) return; // skip auto add

      const userRemovedInsurance =
        sessionStorage.getItem("insurance_removed") === "true";
      if (userRemovedInsurance) return;

      safeFetchCart().then((data) => {
        if (!data) return;

        const insuranceProductId = getInsuranceProductId();
        if (!insuranceProductId) return;

        let hasProducts = false;
        let onlyInsurance = true;
        let enableInsurance = false;

        data.items.forEach((item) => {
          if (item.id != insuranceProductId) {
            hasProducts = true;
            onlyInsurance = false;
          }
        });

        const insuranceItem = data.items.find(
          (item) => item.id == insuranceProductId,
        );
        if (insuranceItem && insuranceItem.quantity > 1) {
          fetch(window.Shopify.routes.root + "/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: insuranceProductId,
              quantity: 1,
            }),
          })
            .then(() => {
              setTimeout(onCartUpdate, 150);
            })
            .catch((err) =>
              console.error("Error resetting insurance quantity:", err),
            );
        }

        if (!hasProducts && onlyInsurance) {
          setTimeout(triggerInsuranceRemove, 2000);
        }

        if (
          lastCartState.hasProducts === hasProducts &&
          lastCartState.onlyInsurance === onlyInsurance
        ) {
          return;
        }

        lastCartState = { hasProducts, onlyInsurance };

        document
          .querySelectorAll(".form__insurance-input")
          .forEach((checkbox) => {
            if (checkbox.dataset.insuranceState === "true") {
              enableInsurance = true;
            }

            const userRemovedInsurance =
              sessionStorage.getItem("insurance_removed") === "true";

            if (enableInsurance && !userRemovedInsurance) {
              checkbox.checked = true;
              triggerInsuranceAdd();
            }
          });

        const userRemovedInsurance2 =
          sessionStorage.getItem("insurance_removed") === "true";

        if (enableInsurance) {
          if (hasProducts && !userRemovedInsurance2) {
            setTimeout(triggerInsuranceAdd, 25);
          }

          if (!hasProducts || onlyInsurance) {
            setTimeout(triggerInsuranceRemove, 25);
          }
        }
      });
    }

    function attachListeners() {
      document.body.addEventListener("click", (event) => {
        const removeButton = event.target.closest("cart-remove-button");

        if (removeButton && isCartPage) {
          const productId = removeButton.dataset.productId;
          const insuranceProductId = getInsuranceProductId();

          if (productId && productId === insuranceProductId) {
            sessionStorage.setItem("insurance_removed", "true");
          }
        }

        if (
          event.target.closest(
            ".quantity__button, .quick-add__submit:not(.cart-submit), .product-form__submit, cart-remove-button",
          )
        ) {
          debounceCartUpdate();
        }
      });

      document.body.addEventListener("change", (event) => {
        const insuranceCheckbox = event.target.closest(
          ".form__insurance-input",
        );

        if (insuranceCheckbox) {
          // Disable only the clicked checkbox
          insuranceCheckbox.disabled = true;

          if (insuranceCheckbox.checked) {
            sessionStorage.removeItem("insurance_removed");
            triggerInsuranceAdd(); // manual add allowed
          } else {
            sessionStorage.setItem("insurance_removed", "true");
            triggerInsuranceRemove();
          }

          debounceCartUpdate();

          // Re enable only this checkbox after the action completes
          setTimeout(() => {
            insuranceCheckbox.disabled = false;
          }, 1000);
        }
      });
    }

    attachListeners();

    if (!observerInitialized) {
      observerInitialized = true;
      const observer = new MutationObserver(() => {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(onCartUpdate, 50);
        debounceTimeout = setTimeout(monitorCartChanges, 50);
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (isCartPage) {
      fetchSettingsAndApply();
      onCartUpdate();
      monitorCartChanges();
      window.addEventListener("load", () => {
        setTimeout(onCartUpdate, 50);
        setTimeout(monitorCartChanges, 50);
      });
    }
  });
})();
// ===== Functionality for Insurance toggle end =====

// ===== About us FAQ tab functionality  start =====
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".tab").forEach((tab) => {
      tab.addEventListener("click", function () {
        document
          .querySelectorAll(".tab")
          .forEach((item) => item.classList.remove("active"));
        document
          .querySelectorAll(".tab-content")
          .forEach((content) => content.classList.remove("active"));

        this.classList.add("active");
        document.getElementById(this.dataset.target).classList.add("active");
      });
    });
  });
})();
// ===== About us tab functionality  end =====

// ===== Hide Smile.io widget functionality start =====
(function () {
  function handleIframeLoad(iframe) {
    if (!iframe) return;

    iframe.addEventListener("load", () => {
      checkAndHideWidget(iframe);
    });

    checkAndHideWidget(iframe);
  }

  function checkAndHideWidget(iframe) {
    if (!iframe) return;

    const url = window.location.pathname;
    const isPDP = url.includes("/products/");
    const isCart = url.startsWith("/cart");
    const cartDrawer = document.querySelector("cart-drawer");
    const cartDrawerHasClasses = cartDrawer.classList.contains("active");

    const shouldHide =
      (isPDP || isCart || cartDrawerHasClasses) && window.innerWidth < 993;

    if (shouldHide || cartDrawerHasClasses) {
      iframe.style.display = "none";
    } else {
      iframe.style.display = "";
    }
  }

  function waitForWidget() {
    const iframe = document.getElementById("smile-ui-container");

    if (iframe) {
      handleIframeLoad(iframe);
    } else {
      // console.log("Waiting for widget iframe...");
      setTimeout(waitForWidget, 500);
    }
  }

  window.addEventListener("load", () => {
    waitForWidget();

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        mutation.addedNodes.forEach((node) => {
          if (node.id === "smile-ui-container") {
            handleIframeLoad(node);
            observer.disconnect();
          }
        });
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });

  window.addEventListener("resize", () => {
    const iframe = document.getElementById("smile-ui-container");
    checkAndHideWidget(iframe);
  });

  document.addEventListener("DOMContentLoaded", () => {
    const observer = new MutationObserver(() => {
      checkAndHideWidget(document.getElementById("smile-ui-container"));
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });

  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    const classObserver = new MutationObserver(() => {
      checkAndHideWidget(document.getElementById("smile-ui-container"));
    });

    classObserver.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }
})();

// ===== Hide Smile.io widget functionality end =====

// ===== Hide Smile.io widget if privacy policy functionality start =====
(function () {
  window.addEventListener("load", () => {
    const privacyPolicy = document.getElementById("shopify-pc__banner");
    if (!privacyPolicy) return;

    let iframe;

    function isBannerVisible() {
      const styles = window.getComputedStyle(privacyPolicy);
      return styles.display !== "none" && styles.visibility !== "hidden";
    }

    function positionWidget() {
      if (!iframe) {
        iframe = document.getElementsByClassName(
          "smile-launcher-frame-container",
        )[0];
      }

      if (iframe) {
        if (isBannerVisible()) {
          const privacyPolicyHeight = privacyPolicy.offsetHeight || 0;
          iframe.style.setProperty(
            "bottom",
            `${privacyPolicyHeight + 10}px`,
            "important",
          );
        } else {
          iframe.style.setProperty("bottom", "20px", "important");
        }
      }
    }

    function waitForWidget() {
      iframe = document.getElementsByClassName(
        "smile-launcher-frame-container",
      )[0];

      if (iframe) {
        positionWidget();
        window.addEventListener("resize", positionWidget);

        const observer = new MutationObserver(() => {
          positionWidget();
        });

        observer.observe(privacyPolicy, {
          attributes: true,
          attributeFilter: ["style", "class"],
        });
      } else {
        // console.log("Waiting for widget iframe...");
        setTimeout(waitForWidget, 300);
      }
    }

    waitForWidget();
  });
})();

// ===== Hide Smile.io widget if privacy policy functionality end =====

// ===== Script for displaying points and tiers in progress bar (smile.io) start =====
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    async function getSmileData() {
      return new Promise((resolve, reject) => {
        if (window.Smile?.legacySmile?.customer) {
          resolve(window.Smile.legacySmile.customer);
        } else {
          reject("Smile legacy customer data not available yet.");
        }
      });
    }

    async function getSmileDataWithRetry(retries = 10, delay = 500) {
      for (let i = 0; i < retries; i++) {
        try {
          const data = await getSmileData();
          return data;
        } catch (error) {
          if (i === retries - 1) throw new Error("Failed to load Smile data.");
          await new Promise((resolve) => setTimeout(resolve, delay));
        }
      }
    }

    async function updateProgressBar() {
      const pointsElement = document.querySelector(
        ".loyalty-welcome__points-balance",
      );
      const pointsLabelElement = pointsElement?.nextElementSibling;
      const messageElement = document.querySelector(
        ".loyalty-welcome__points-left",
      );
      const progressBar = document.querySelector(
        ".loyalty-welcome__progress-bar",
      );

      if (
        !pointsElement ||
        !pointsLabelElement ||
        !messageElement ||
        !progressBar
      ) {
        console.warn("Required elements not found on the page.");
        return;
      }

      const tiers = {
        126: {
          name: progressBar.dataset.tierFresh,
          showRetention: false,
          progress: 0,
        },
        128: {
          name: progressBar.dataset.tierCollector,
          showRetention: true,
          progress: 50,
        },
        127: {
          name: progressBar.dataset.tierAddict,
          isHighest: true,
          progress: 100,
        },
        // TODO: Enable when Eau 'Influencer' (ID 129) once is live in smile.io app
        // 129: {
        //   name: progressBar.dataset.tierInfluencer,
        //   isHighest: true,
        //   progress: 100,
        // },
        // },
      };
      const tierOrder = [126, 128, 127]; // Fresh -> Collector -> Addict

      try {
        messageElement.textContent =
          messageElement.dataset.loadingText || "Loading...";
        pointsElement.textContent = "";
        pointsLabelElement.textContent =
          pointsLabelElement.dataset.loadingText || "Loading...";

        // Get Smile customer data
        const customer = await getSmileDataWithRetry();
        const {
          vip_tier_id: vipTierId,
          points_balance: pointsBalance,
          delta_to_next_vip_tier_formatted,
          delta_to_retain_vip_tier_formatted,
          current_vip_period_end_formatted,
          next_vip_period_end_formatted,
        } = customer;

        const tier = tiers[vipTierId];
        // testing purposes
        // console.log(vipTierId, tierOrder);

        if (!tier) {
          console.warn(`Unknown VIP tier ID: ${vipTierId}`);
          return;
        }

        progressBar.style.setProperty("--progress-width", `${tier.progress}%`);

        // Activate tiers (order-based, not id based)
        const tierElements = document.querySelectorAll(
          ".loyalty-progress-bar__tier",
        );

        tierElements.forEach((el) => el.classList.remove("active"));

        const currentTierIndex = tierOrder.indexOf(vipTierId);

        if (currentTierIndex === -1) {
          console.warn("VIP tier not found in tierOrder:", vipTierId);
          return;
        }

        tierElements.forEach((el, index) => {
          if (index <= currentTierIndex) {
            el.classList.add("active");
          }
        });
        // TODO: Uncomment when Influencer tier (ID 129) is available
        // if (vipTierId >= 129)
        //   document
        //     .querySelector(".loyalty-progress-bar__fourth-tier")
        //     ?.classList.add("active");

        pointsElement.textContent = pointsBalance;
        pointsLabelElement.textContent =
          pointsLabelElement.dataset.pointsLabel || "Points";

        let message = "";

        // Eau 'Addict' (Highest tier for now)
        if (tier.isHighest) {
          message = `
          <strong>${tier.name}</strong><br>
          Member until ${next_vip_period_end_formatted}<br>
          Congratulations, you're in the highest tier
        `;
        }

        // Eau 'Fresh'
        else if (vipTierId === 126) {
          message = `
          <strong>${tier.name}</strong><br>
          Earn ${delta_to_next_vip_tier_formatted} by ${current_vip_period_end_formatted}<br>
          to reach ${progressBar.dataset.tierCollector}
        `;
        }

        // Eau 'Collector' (retention logic)
        else if (tier.showRetention) {
          message = `
          <strong>${tier.name}</strong><br>
          Member until ${current_vip_period_end_formatted}<br>
          Earn ${delta_to_retain_vip_tier_formatted} by ${current_vip_period_end_formatted}<br>
          to keep your ${tier.name} status until ${next_vip_period_end_formatted}
        `;
        }

        messageElement.innerHTML = message;
      } catch (error) {
        console.error("Error updating progress bar:", error);
        messageElement.textContent = "Failed to load data.";
        pointsLabelElement.textContent = "";
      }
    }

    updateProgressBar();
  });
})();
// ===== Script for displaying points and tiers in progress bar (smile.io) end =====

// ===== Animation for details summary tags start =====
(function () {
  class Accordion {
    constructor(el) {
      // Store the <details> element
      this.el = el;
      // Store the <summary> element
      this.summary = el.querySelector(
        "summary:not(.mobile-facets__summary):not(.mobile-facets__open-wrapper)",
      );
      // Store the <div class="content"> element
      this.content = el.querySelector(".accordion-custom__content");

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
      // Detect user clicks on the summary element
      if (this.summary) {
        this.summary.addEventListener("click", (e) => this.onClick(e));
      }
    }

    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.el.style.overflow = "hidden";
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.el.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.el.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.el.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: "ease-out",
        },
      );

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      // Apply a fixed height on the element
      this.el.style.height = `${this.el.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.el.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.el.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.el.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: "ease-out",
        },
      );
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.el.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.el.style.height = this.el.style.overflow = "";
    }
  }

  document
    .querySelectorAll("details:not(.mobile-facets__disclosure)")
    .forEach((el) => {
      new Accordion(el);
    });
})();
// ===== Animation for details summary tags end =====

// ===== In stock preselected for product type and concentration start =====
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    // Config/lists
    const targetValues = new Set([
      // Product Type
      "Boxed",
      "Decant",
      "Gift Set",
      "Other",
      "Pre-owned",
      "Tester",
      // Gender
      "Man",
      "Woman",
      "Unisex",
      "Girls",
      "Boys",
      "Not Specified",
      "Kids",
      // Concentration
      "Eau De Cologne",
      "Eau De Parfum",
      "Eau De Toilette",
      "Eau Fraiche",
      "Extrait De Parfum",
      "Oil",
      "Parfum",
      "Pure Perfume",
      // Volume
      "Greater than 200ml",
      "50ml to 200ml",
      "Less Than 50ml",
    ]);

    const productTypeValues = new Set([
      "Boxed",
      "Decant",
      "Gift Set",
      "Other",
      "Pre-owned",
      "Tester",
    ]);

    const availabilityCheckboxId = "Filter-filter.v.availability-1";

    // Helpers to inspect the URL
    function getProductTypesFromUrl() {
      const params = new URLSearchParams(window.location.search);
      let values = params.getAll("filter.v.m.search_filter.product_type");

      if (!values.length) {
        const single = params.get("filter.v.m.search_filter.product_type");
        if (single) values = [single];
      }

      values = values
        .flatMap((v) => String(v).split(","))
        .map((v) => v.trim())
        .filter((v) => v.length && productTypeValues.has(v));
      // Dedupe
      return [...new Set(values)];
    }

    function urlHasFilterParams() {
      const params = new URLSearchParams(window.location.search);
      return (
        params.has("filter.v.m.search_filter.product_type") ||
        params.has("filter.v.availability")
      );
    }

    // If landing on a URL with filters -> save/overwrite sessionStorage immediately
    function saveInitialFiltersFromUrl() {
      if (!urlHasFilterParams()) return;

      const urlProductTypes = getProductTypesFromUrl();
      const params = new URLSearchParams(window.location.search);
      const availability = params.get("filter.v.availability");

      if (urlProductTypes.length) {
        sessionStorage.setItem(
          "selectedProductTypes",
          JSON.stringify(urlProductTypes),
        );
        // console.log("Saved selectedProductTypes from URL:", urlProductTypes);
      }

      if (availability === "1") {
        sessionStorage.setItem("availabilityChecked", "true");
        // console.log("Saved availabilityChecked from URL: true");
      } else if (availability === "0") {
        sessionStorage.setItem("availabilityChecked", "false");
        // console.log("Saved availabilityChecked from URL: false");
      }
    }

    saveInitialFiltersFromUrl();

    const path = window.location.pathname;
    const isCollection = path.startsWith("/collections/");
    const isSearch = path.startsWith("/search");
    if (!isCollection && !isSearch) return;

    // Save/Restore functions
    function saveFilterState() {
      const selectedProductTypes = Array.from(
        document.querySelectorAll('input[type="checkbox"]'),
      )
        .filter((input) => productTypeValues.has(input.value) && input.checked)
        .map((input) => input.value);

      const deduped = [...new Set(selectedProductTypes)];
      sessionStorage.setItem("selectedProductTypes", JSON.stringify(deduped));
      // console.log("Saved selectedProductTypes:", deduped);

      const availabilityCheckbox = document.getElementById(
        availabilityCheckboxId,
      );
      if (availabilityCheckbox) {
        sessionStorage.setItem(
          "availabilityChecked",
          availabilityCheckbox.checked.toString(),
        );
        // console.log(
        //   "Saved availabilityChecked:",
        //   availabilityCheckbox.checked.toString(),
        // );
      }
    }

    function applySavedFilters() {
      // If the current URL itself provides filters, do not overwrite UI here
      if (urlHasFilterParams()) {
        // console.log(
        //   "Page has URL filters - skipping applying sessionStorage values.",
        // );
        return false;
      }

      const savedProductTypes = JSON.parse(
        sessionStorage.getItem("selectedProductTypes") || "[]",
      );
      const availabilityChecked =
        sessionStorage.getItem("availabilityChecked") === "true";

      let didClick = false;

      savedProductTypes.forEach((val) => {
        const input = document.querySelector(
          `input[type="checkbox"][value="${val}"]`,
        );
        if (input && !input.checked) {
          input.click();
          // console.log("Clicking product type checkbox for:", val);
          didClick = true;
        }
      });

      if (availabilityChecked) {
        const availabilityCheckbox = document.getElementById(
          availabilityCheckboxId,
        );
        if (availabilityCheckbox && !availabilityCheckbox.checked) {
          availabilityCheckbox.click();
          // console.log("Clicking availability checkbox (auto)");
          didClick = true;
        }
      }

      return didClick;
    }

    // Helper: resolves when target inputs/availability control appear (or timeout)
    function waitForFilterControls(timeout = 4000) {
      return new Promise((resolve) => {
        const found =
          document.getElementById(availabilityCheckboxId) ||
          Array.from(productTypeValues).some((val) =>
            document.querySelector(`input[type="checkbox"][value="${val}"]`),
          );

        if (found) {
          resolve(true);
          return;
        }

        const observer = new MutationObserver((mutations, obs) => {
          const nowFound =
            document.getElementById(availabilityCheckboxId) ||
            Array.from(productTypeValues).some((val) =>
              document.querySelector(`input[type="checkbox"][value="${val}"]`),
            );

          if (nowFound) {
            obs.disconnect();
            resolve(true);
          }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        setTimeout(() => {
          observer.disconnect();
          resolve(false);
        }, timeout);
      });
    }

    (async function tryRestore() {
      const ready = await waitForFilterControls(4000);
      if (ready) {
        const clicked = applySavedFilters();
        if (clicked) {
          observeFilterContentUpdate(() => {
            // console.log("Scrolled to top after filters updated");
            window.scrollTo({ top: 0, behavior: "smooth" });
          });
        }
      } else {
        // Fallback: set a MutationObserver to wait and then apply once controls appear
        const observer = new MutationObserver((mutations, obs) => {
          const anyInputsExist =
            document.getElementById(availabilityCheckboxId) ||
            Array.from(productTypeValues).some((val) =>
              document.querySelector(`input[type="checkbox"][value="${val}"]`),
            );
          if (anyInputsExist) {
            obs.disconnect();
            const clicked = applySavedFilters();
            if (clicked) {
              observeFilterContentUpdate(() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
              });
            }
          }
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }
    })();

    // Helper: used to wait until product grid updates after clicking filters
    function observeFilterContentUpdate(callback) {
      const container =
        document.getElementById("ProductGridContainer") || document.body;

      const isProductGridNode = (node) =>
        node.nodeType === Node.ELEMENT_NODE &&
        (node.classList.contains("product-grid") ||
          node.querySelector?.(".product-grid"));

      const observer = new MutationObserver((mutations, observerInstance) => {
        const contentUpdated = mutations.some(({ addedNodes }) =>
          Array.from(addedNodes).some(isProductGridNode),
        );

        if (contentUpdated) {
          observerInstance.disconnect();
          callback();
        }
      });

      observer.observe(container, {
        childList: true,
        subtree: true,
      });
    }

    // Delegated handlers: change (auto-toggle availability + save), click (clear buttons)
    document.body.addEventListener("change", function (e) {
      if (
        e.target.matches('input[type="checkbox"]') &&
        targetValues.has(e.target.value)
      ) {
        const availabilityCheckbox = document.getElementById(
          availabilityCheckboxId,
        );
        if (!availabilityCheckbox) return;

        const checkedTargets = Array.from(
          document.querySelectorAll('input[type="checkbox"]'),
        ).filter((input) => targetValues.has(input.value) && input.checked);

        const anyChecked = checkedTargets.length > 0;

        if (anyChecked && !availabilityCheckbox.checked) {
          availabilityCheckbox.click();
          // console.log("Checked availability (auto due to target check)");
        } else if (!anyChecked && availabilityCheckbox.checked) {
          availabilityCheckbox.click();
          // console.log(
          //   "Unchecked availability (auto due to all targets unchecked)",
          // );
        }

        // Save state if it's product-type or availability
        if (
          productTypeValues.has(e.target.value) ||
          e.target.id === availabilityCheckboxId
        ) {
          saveFilterState();
        }
      }
    });

    // Delegated click handler for clear/facet remove buttons
    document.body.addEventListener("click", function (e) {
      if (e.target.closest(".active-facets__button-remove")) {
        sessionStorage.removeItem("selectedProductTypes");
        sessionStorage.removeItem("availabilityChecked");
        // console.log(
        //   "Cleared sessionStorage for selectedProductTypes and availabilityChecked",
        // );
        return;
      }

      const removeButton = e.target.closest(".active-facets__button");
      if (!removeButton) return;

      if (removeButton.classList.contains("product-type")) {
        sessionStorage.removeItem("selectedProductTypes");
        // console.log("Cleared sessionStorage for selectedProductTypes");
      }

      if (removeButton.classList.contains("availability")) {
        sessionStorage.removeItem("availabilityChecked");
        // console.log("Cleared sessionStorage for availabilityChecked");
      }
    });

    // console.log("Filter session-sync script initialized");
  });
})();
// ===== In stock preselected for product type and concentration end =====

// ===== Back in stock check date metafield functionality start =====
(function () {
  function parseToSafeDate(rawDate) {
    if (!rawDate || typeof rawDate !== "string") return null;

    const dateStr = rawDate.replace(/\//g, "-");

    const parts = dateStr.split("-").map((p) => p.trim());

    let year, month, day;

    if (parts.length !== 3) return null;

    if (parts[0].length === 4) {
      [year, month, day] = parts;
    } else if (parts[2].length === 4) {
      year = parts[2];

      if (Number(parts[0]) > 12) {
        day = parts[0];
        month = parts[1];
      } else {
        month = parts[0];
        day = parts[1];
      }
    } else {
      return null;
    }

    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  function checkRestockDate() {
    const span = document.getElementById("restock-message");
    const rawDate = span?.dataset?.date;
    console.log("[checkRestockDate] data-date:", rawDate);

    if (!span || !rawDate) {
      span?.style && (span.style.display = "none");
      return;
    }

    const variantDate = parseToSafeDate(rawDate);
    if (!variantDate || isNaN(variantDate.getTime())) {
      span.style.display = "none";
      return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (variantDate > today) {
      span.style.display = "block";
    } else {
      span.style.display = "none";
    }
  }

  function runRestockCheckWhenReady() {
    const check = () => {
      const span = document.getElementById("restock-message");
      if (span) {
        checkRestockDate();
      } else {
        setTimeout(check, 100);
      }
    };
    check();
  }

  function monitorURLChanges(callback) {
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    function runIfURLChanged(method) {
      return function () {
        const result = method.apply(this, arguments);
        callback();
        return result;
      };
    }

    history.pushState = runIfURLChanged(originalPushState);
    history.replaceState = runIfURLChanged(originalReplaceState);
    window.addEventListener("popstate", callback);
  }

  document.addEventListener("DOMContentLoaded", function () {
    if (!window.location.pathname.includes("/products/")) return;

    runRestockCheckWhenReady();

    monitorURLChanges(() => {
      setTimeout(() => {
        runRestockCheckWhenReady();
      }, 0);
    });
  });
})();
// ===== Back in stock check date metafield functionality end =====

// ===== Remove all tags except of link in collection description functionality start =====
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const allowedTags = new Set(["P", "BR", "B", "A", "EM", "U", "STRONG"]);
    let cachedSanitizedHTML = null;
    let minHeightPlaceholder = null;

    function isMeaningful(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent.trim() !== "";
      }
      if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.tagName === "A" && node.getAttribute("href")) return true;
        return node.textContent.trim() !== "";
      }
      return false;
    }

    function trimWrapper(wrapper) {
      while (wrapper.firstChild && !isMeaningful(wrapper.firstChild)) {
        wrapper.removeChild(wrapper.firstChild);
      }
      while (wrapper.lastChild && !isMeaningful(wrapper.lastChild)) {
        wrapper.removeChild(wrapper.lastChild);
      }
    }

    function clean(node) {
      const children = Array.from(node.childNodes);
      for (const child of children) {
        if (child.nodeType === Node.ELEMENT_NODE) {
          const tag = child.tagName.toUpperCase();

          clean(child);

          if (!allowedTags.has(tag)) {
            while (child.firstChild) {
              node.insertBefore(child.firstChild, child);
            }
            node.removeChild(child);
          } else {
            if (tag === "A") {
              const href = child.getAttribute("href");
              for (const attr of [...child.attributes]) {
                if (attr.name !== "href") child.removeAttribute(attr.name);
              }
              if (!href) child.removeAttribute("href");
            } else {
              for (const attr of [...child.attributes]) {
                child.removeAttribute(attr.name);
              }
            }
          }
        } else if (child.nodeType !== Node.TEXT_NODE) {
          node.removeChild(child);
        }
      }
    }

    function sanitizeElement(desc) {
      const wrapper = document.createElement("div");
      wrapper.innerHTML = desc.innerHTML;
      clean(wrapper);
      trimWrapper(wrapper);
      return wrapper.innerHTML;
    }

    function sanitizeDescription() {
      const desc = document.getElementById("collection-desc");
      if (!desc) return;

      if (cachedSanitizedHTML) {
        desc.style.minHeight = `${minHeightPlaceholder}px`;
        desc.innerHTML = cachedSanitizedHTML;
        desc.style.opacity = "1";
      } else {
        cachedSanitizedHTML = sanitizeElement(desc);
        desc.innerHTML = cachedSanitizedHTML;
        desc.style.opacity = "1";
        minHeightPlaceholder = desc.offsetHeight;
      }
    }

    sanitizeDescription();

    document.addEventListener("collection:updated", () => {
      sanitizeDescription();
    });
  });
})();

// ===== Remove all tags except of link in collection description functionality end =====

// ===== Functional for Sorting by New Arrival start =====
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    document.body.addEventListener("change", function (event) {
      const sortSelect = event.target.closest(".new-arrival-select");

      if (sortSelect && event.target.value === "collections/newdrops") {
        event.preventDefault();

        // #1 Get current URL parameters
        const urlParams = new URLSearchParams(window.location.search);

        // #2 Remove "q" and "sort_by" parameters
        urlParams.delete("q");
        urlParams.delete("sort_by");

        // #3 Construct the new URL with cleaned parameters
        const newUrl =
          urlParams.toString() !== ""
            ? `/collections/newdrops?${urlParams.toString()}`
            : "/collections/newdrops";

        // #4 Redirect to the new URL
        window.location.href = newUrl;
      }
    });
  });
})();
// ===== Functional for Sorting by New Arrival end =====

// ===== Functionality for tracking applied filters on mobile start =====
function observeActiveFacets() {
  const target = document.querySelector(".active-facets.active-facets-mobile");
  if (!target) return;

  const toggleActiveClass = () => {
    const hasFacetRemove = target.querySelector("facet-remove:not([class])");
    target.classList.toggle("active", !!hasFacetRemove);
  };

  toggleActiveClass();

  const observer = new MutationObserver(toggleActiveClass);
  observer.observe(target, { childList: true, subtree: true });
}

observeActiveFacets();
// ===== Functionality for tracking applied filters on mobile end =====
// ===== Swiper for infinite line start =====
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const swiperEl = document.querySelector(".infinite-line-swiper");

    if (!swiperEl) {
      return;
    }

    const swiper = new Swiper(swiperEl, {
      slidesPerView: "auto",
      spaceBetween: 20,
      speed: 8000,
      freeMode: true,
      freeModeMomentum: false,
      allowTouchMove: true,
      grabCursor: true,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
      },
    });
  });
})();
// ===== Swiper for infinite line end =====

// // ===== Functional newsletter popup start =====
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const openBtn = document.getElementById("newsletter-subscribe");
    const popup = document.getElementById("newsletter-popup");
    const closeBtn = document.getElementById("popup-close-btn");
    const overlay = document.getElementById("popup-close");

    function togglePopup(show) {
      popup.classList.toggle("hidden", !show);

      if (show) {
        document.documentElement.classList.add("newsletter-popup-open");
      } else {
        document.documentElement.classList.remove("newsletter-popup-open");
      }
    }

    popup.addEventListener("click", (e) => {
      if (e.target.classList.contains("popup")) {
        togglePopup(false);
      }
    });

    if (openBtn) openBtn.addEventListener("click", () => togglePopup(true));
    if (closeBtn) closeBtn.addEventListener("click", () => togglePopup(false));
    if (overlay) overlay.addEventListener("click", () => togglePopup(false));
  });
})();
// // ===== Functional newsletter popup end =====

// // ===== Custom notify me modal start =====
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("click", function (e) {
      const trigger = e.target.closest(".notify-me__trigger");
      if (!trigger) return;

      e.preventDefault();

      const productId = trigger.dataset.productId;
      const sectionId = trigger.dataset.sectionId;
      const variantId = trigger.dataset.variantId;
      const wrapperId = `custom-bis-wrapper-${productId}-${sectionId}`;

      const formWrapper = document.getElementById(wrapperId);
      const form = document.getElementById(
        `custom-bis-form-${productId}-${sectionId}`,
      );
      const emailInput = document.getElementById(
        `bis-email-${productId}-${sectionId}`,
      );
      const closeBtn = document.getElementById(
        `close-bis-form-${productId}-${sectionId}`,
      );
      const selectedTitleContainer = document.getElementById(
        `selected-variant-title-${productId}-${sectionId}`,
      );

      if (!formWrapper || !form || !emailInput || !closeBtn) {
        console.warn("Missing Notify Me elements for product", productId);
        return;
      }

      // Move modal to top of body if needed
      const isOnProduct = formWrapper.dataset.isOnProduct;
      if (
        isOnProduct === "true" &&
        formWrapper.parentElement !== document.body.firstChild
      ) {
        document.body.insertBefore(formWrapper, document.body.firstChild);
      }

      // Show the form
      formWrapper.style.display = "flex";

      // Set checked variant
      const variantInput = form.querySelector(
        `input[name="variant_id"][value="${variantId}"]`,
      );
      if (variantInput) {
        variantInput.checked = true;

        const label = document
          .querySelector(`label[for="${variantInput.id}"]`)
          .getAttribute("data-variant-title");
        if (label && selectedTitleContainer) {
          selectedTitleContainer.textContent = label;
        }
      }

      // Close button
      closeBtn.addEventListener(
        "click",
        () => {
          formWrapper.style.display = "none";
          form.reset();
        },
        { once: true },
      );

      // Variant input title change
      const variantInputs = form.querySelectorAll('input[name="variant_id"]');
      variantInputs.forEach((input) => {
        input.addEventListener("change", function () {
          const label = document
            .querySelector(`label[for="${this.id}"]`)
            .getAttribute("data-variant-title");
          if (label && selectedTitleContainer) {
            selectedTitleContainer.textContent = label;
          }
        });
      });

      // Submit handler
      form.addEventListener("submit", function (e) {
        e.preventDefault();

        const email = emailInput.value.trim();
        const selectedVariantId = form.querySelector(
          'input[name="variant_id"]:checked',
        )?.value;

        if (!email || !selectedVariantId || !productId) {
          alert("Missing email, variant, or product ID.");
          return;
        }

        if (typeof BIS === "undefined" || typeof BIS.create !== "function") {
          alert("BIS library not loaded.");
          return;
        }

        function showRequestResult(isOk, response) {
          const resultContainer = document.getElementById(
            `bis-result-message-${productId}-${sectionId}`,
          );

          if (!resultContainer) return;

          const messageClass = isOk
            ? "bis-request-result__message--success"
            : "bis-request-result__message--failed";

          const message =
            response.status === "OK"
              ? response.message
              : response.errors?.base?.[0] || "Unexpected error";

          resultContainer.textContent = message;
          resultContainer.classList.add(messageClass);
          resultContainer.style.display = "block";
          form.reset();

          setTimeout(() => {
            resultContainer.style.display = "none";
            resultContainer.classList.remove(
              "bis-request-result__message--success",
              "bis-request-result__message--failed",
            );
          }, 5000);
        }

        BIS.create(email, parseInt(selectedVariantId), parseInt(productId))
          .then(function (response) {
            if (response.status === "OK") {
              showRequestResult(true, response);
            } else {
              showRequestResult(false, response);
            }
          })
          .catch(function (error) {
            console.error("BIS error:", error);
          });
      });
    });
  });
})();

// // ===== Custom notify me modal end =====

// // ===== Accordion start =====
(function () {
  function togglePanelAccessibility(panel, isOpen) {
    const focusableElements = panel.querySelectorAll(
      'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])',
    );
    focusableElements.forEach((element) => {
      if (isOpen) {
        element.removeAttribute("tabindex");
      } else {
        element.setAttribute("tabindex", "-1");
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    const accordionItems = document.querySelectorAll("[data-accordion-item]");

    accordionItems.forEach((item) => {
      const panel = item.querySelector("[data-accordion-content]");
      const trigger = item.querySelector("[data-accordion-trigger]");
      const isActive = panel.classList.contains("active");
      const isMegaMenu = panel.closest(".mega-menu__featured-collections");

      if (isActive) {
        if (isMegaMenu) {
          panel.style.height = "auto";
        } else {
          panel.style.height = panel.scrollHeight + 20 + "px";
        }

        trigger.setAttribute("aria-expanded", "true");
        togglePanelAccessibility(panel, true);
      } else {
        panel.style.height = "0px";
        trigger.setAttribute("aria-expanded", "false");
        togglePanelAccessibility(panel, false);
      }
    });

    const open = (button, panel) => {
      closeAllPanels(button, panel);

      const isMegaMenu = panel.closest(".mega-menu__featured-collections");

      if (isMegaMenu) {
        panel.style.height = panel.scrollHeight + "px";
      } else if (panel.getAttribute("data-accordion-type") === "junip") {
        panel.style.height = "fit-content";
      } else {
        panel.style.height = panel.scrollHeight + 20 + "px";
      }

      button.classList.add("active");
      panel.classList.add("active");
      button.setAttribute("aria-expanded", "true");
      togglePanelAccessibility(panel, true);
    };

    const close = (button, panel) => {
      panel.style.height = panel.scrollHeight + "px";

      panel.offsetHeight;

      button.classList.remove("active");
      panel.classList.remove("active");
      panel.style.height = "0px";
      button.setAttribute("aria-expanded", "false");
      togglePanelAccessibility(panel, false);
    };

    const closeAllPanels = (currentButton, currentPanel) => {
      accordionItems.forEach((item) => {
        const button = item.querySelector("[data-accordion-trigger]");
        const panel = item.querySelector("[data-accordion-content]");

        if (button !== currentButton && panel !== currentPanel) {
          close(button, panel);
        }
      });
    };

    document.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-accordion-trigger]");

      if (trigger) {
        event.preventDefault();
        const item = trigger.closest("[data-accordion-item]");
        const panel = item.querySelector("[data-accordion-content]");

        if (panel.classList.contains("active")) {
          close(trigger, panel);
        } else {
          open(trigger, panel);
        }
      }
    });

    document.addEventListener("keydown", (event) => {
      const trigger = event.target.closest("[data-accordion-trigger]");

      if (trigger && (event.key === "Enter" || event.key === " ")) {
        event.preventDefault();
        trigger.click();
      }
    });
  });

  // === JUNIP bridge start ===
  function handleJunipAction(event) {
    if (
      event.type === "click" ||
      (event.type === "keydown" && event.key === "Enter")
    ) {
      const clickable = event.target.closest(
        ".junip-product-summary-clickable",
      );
      if (!clickable) return;

      event.preventDefault();

      const accordionJunip = document.querySelector(".accordion__junip");
      if (!accordionJunip) return;

      const trigger = accordionJunip.querySelector("[data-accordion-trigger]");
      const panel = accordionJunip.querySelector("[data-accordion-content]");

      if (trigger && panel) {
        if (!panel.classList.contains("active")) {
          trigger.classList.add("active");
          panel.classList.add("active");
          trigger.setAttribute("aria-expanded", "true");

          const isMegaMenu = panel.closest(".mega-menu__featured-collections");

          panel.style.height = isMegaMenu
            ? panel.scrollHeight + "px"
            : panel.getAttribute("data-accordion-type") === "junip"
              ? (panel.style.height = "fit-content")
              : panel.scrollHeight + 20 + "px";

          togglePanelAccessibility(panel, true);
        }
      }
    }
  }
  document.body.addEventListener("click", handleJunipAction);
  document.body.addEventListener("keydown", handleJunipAction);
  // === JUNIP bridge end ===
})();
// // ===== Accordion end =====
